import './ui/style.css';
import { mount } from './ui/app';

const app = document.querySelector<HTMLDivElement>('#app');
if (app) {
  void mount(app);
  // A same-document navigation to/from #admin doesn't reload the page, so
  // re-check the route explicitly rather than relying only on the initial mount.
  window.addEventListener('hashchange', () => void mount(app));
}
